//
// Copyright 2022 DXOS.org
//

export const staticDisabled = 'opacity-40 cursor-not-allowed shadow-none';
export const dataDisabled = 'data-[disabled]:opacity-40 data-[disabled]:cursor-not-allowed';
